import React, { useEffect, useState } from 'react';
import { FAQ } from '../../models/FAQ';
import Navbar from '../../components/admin/Navbar.tsx';
import { addQuestion, deleteQuestion, editQuestion, getQuestionIdByTitleAndContent, showFAQ } from '../../services/admin/FAQService.tsx';
import '../../styles/admin/FAQ.css';
import { FaRegEdit } from "react-icons/fa";
import { TiDeleteOutline } from "react-icons/ti";
import { SyncLoader } from "react-spinners";


export const FrequentQuestionsAdmin = () => {

    const [faq, setFaq] = useState<FAQ[]>([]);
    const [activeIndices, setActiveIndices] = useState<number[]>([]);
    const [formData, setFormData] = useState({ title: '', content: '' });
    const [editingQuestionId, setEditingQuestionId] = useState('');
    const [deleteItem, setDeleteItem] = useState<FAQ | null>(null);
    const [isLoading, setIsLoading] = useState(false);

    const handleChange = (e:any) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const handleEdit = async (question: any) => {
        setFormData({ title: question.title, content: question.content });
        const questionId = await getQuestionIdByTitleAndContent(question.title, question.content);
        setEditingQuestionId(questionId);
    };

    const handleSubmit = async (e: any) => {
        e.preventDefault();
        if (editingQuestionId) {
            await editQuestion(editingQuestionId, formData);
            setEditingQuestionId('');
        } else {
            await addQuestion(formData);
        }
        setFormData({ title: '', content: '' });
        await loadFAQ();
    };

    const handleDeleteClick = (item:any ) => {
        setDeleteItem(item);
    };

    const handleDelete = async () => {
        if (deleteItem) {
            await deleteQuestion(deleteItem.title, deleteItem.content);
            await loadFAQ();
            setDeleteItem(null);
        }
    };

    const toggleAccordion = (index:any) => {
        if (activeIndices.includes(index)) {
            setActiveIndices(activeIndices.filter((i) => i !== index));
        } else {
            setActiveIndices([...activeIndices, index]);
        }
    };

    const loadFAQ = async () => {
        setIsLoading(true);
        const quetions = await showFAQ();
        setFaq(quetions);
        setIsLoading(false);
    }
    const sortedFaq = [...faq].sort((a, b) => a.order - b.order);

    useEffect(() => {
        loadFAQ();
    }, []);

    return (
        <>
            {isLoading ? (
                <div className="loader-container">
                    <SyncLoader color="#0A2240" margin={5} size={20} speedMultiplier={1} />
                </div>
            ) : (
                <div>
                    <div className='container-fluid'>
                        <div className='col-lg-12 col-xs-12'>
                            <div className='FAQ-container'>
                                <span className='teko FAQ'>ADD QUESTION</span>
                            </div>
                        </div>
                        <form onSubmit={handleSubmit} className='mt-2'>
                            <div>
                                <input type="text" placeholder='Question' name="title" className='form-question' value={formData.title} onChange={handleChange} required />
                            </div>
                            <div>
                                <textarea placeholder='Answer' name="content" className='form-question mt-2' value={formData.content} onChange={handleChange} required />
                            </div>
                            <div className="button-container">
                                <button type="submit" className='button-question mt-2'>{editingQuestionId ? 'Edit question' : 'Add question'}</button>
                            </div>
                        </form>
                    </div>
                    <div className='container-fluid'>
                        <div className='row'>
                            <div className='col-lg-12 col-xs-12'>
                                <div className='FAQ-container'>
                                    <span className='teko FAQ'>FREQUENTLY ASKED QUESTIONS</span>
                                </div>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-lg-11 col-xs-12'>
                                <div className="accordion">
                                    {sortedFaq.map((item, index) => (
                                        <div className="accordion-item" key={index}>
                                            <div className={`accordion-title teko ${activeIndices.includes(index) ? 'active' : ''}`} onClick={() => toggleAccordion(index)}>
                                                {item.title}
                                                <div className='button-edith-question'>
                                                    <button onClick={(e) => { e.stopPropagation(); handleEdit(item); }} className='edit-questions'><FaRegEdit className="question-icon" /></button>
                                                    <button onClick={(e) => { e.stopPropagation(); handleDeleteClick(item); }} className='delete-questions'><TiDeleteOutline className="question-icon" data-bs-toggle="modal" href="#exampleModalToggle" role="button" /></button>
                                                </div>
                                            </div>
                                            <div className={`accordion-content teko ${activeIndices.includes(index) ? 'active' : ''}`}>
                                                {item.content}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className="modal fade" id="exampleModalToggle" aria-hidden="true" aria-labelledby="exampleModalToggleLabel" tabIndex={-1}>
                            <div className="modal-dialog modal-dialog-centered">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h1 className="modal-title fs-5" id="exampleModalToggleLabel">Delete question</h1>
                                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                    </div>
                                    <div className="modal-body">
                                        Are you sure you want to delete this question?
                                    </div>
                                    <div className="modal-footer">
                                        <button onClick={handleDelete} className='delete-questions' data-bs-target="#exampleModalToggle" data-bs-toggle="modal" data-bs-dismiss="modal">Delete</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

